
import axios from 'axios';
import { LLMCBResponse } from '../../types/llm';

export const getCBResults = async (
  premise: string,
  hypothesis: string
) => {
  return await axios
    .post<LLMCBResponse>(
      `${process.env.REACT_APP_BACKEND_URL}/llm/cb`,
      {
        premise: premise,
        hypothesis: hypothesis,
      }
    )
    .then((response) => {
      return response.data;
    });
};
